import React from 'react';

export function AuthCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex flex-col w-full h-full items-center justify-center bg-[url(/img/login_bg.jpg)] bg-no-repeat bg-top bg-cover opacity-[1] transition-opacity duration-400 ease-in-out">
      <div className="flex flex-col justify-center xs:h-full sm:min-h-1/2 w-full sm:w-2/3 md:w-1/2 overflow-hidden rounded-lg bg-white shadow-sm">
        <div className="p-12">
          {children}
        </div>
      </div>
    </div>
  );
}
